import React from 'react';
import { Shield, Users, Award, TrendingUp } from 'lucide-react';

export const About = () => {
  const highlights = [
    {
      icon: Shield,
      title: "Registered & Compliant",
      description: "Registered entity under the Labour Act with complete legal compliance"
    },
    {
      icon: Users,
      title: "Expert Leadership",
      description: "Team of retired defense personnel, police officers, and legal experts"
    },
    {
      icon: Award,
      title: "Quality Assured",
      description: "Tri-layered daily site health checks for consistent excellence"
    },
    {
      icon: TrendingUp,
      title: "NCR Leader",
      description: "Leading manpower solutions provider in the National Capital Region"
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="space-y-3">
              <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                About Unity Group
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
                Your Trusted Partner in Complete Manpower Solutions
              </h2>
            </div>

            <p className="text-lg text-slate-600 leading-relaxed">
              Unity Group Services is a multi-faceted service provider offering expert solutions in <span className="font-semibold text-slate-900">Security, Facility Management, and Housekeeping</span> with unmatched professionalism and commitment to excellence.
            </p>

            <p className="text-lg text-slate-600 leading-relaxed">
              Our leadership comprises experienced professionals including <span className="font-semibold text-slate-900">lawyers, retired defense personnel, and former police officers</span>, bringing decades of expertise in security and facility management to serve corporate and residential environments.
            </p>

            <div className="pt-6 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-slate-700">
                  <span className="font-semibold">Rigorous Recruitment:</span> Multi-stage selection process ensuring only the best talent joins our team
                </p>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-slate-700">
                  <span className="font-semibold">Technology-Driven:</span> GPS tracking, body cameras, and real-time monitoring for enhanced security
                </p>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <p className="text-slate-700">
                  <span className="font-semibold">Strong Clientele:</span> Trusted by leading organizations across NCR region
                </p>
              </div>
            </div>
          </div>

          {/* Right Content - Highlights Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {highlights.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-blue-200 group"
                >
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
